import { Component, Element, h, Host, Prop } from "@stencil/core";
import { WidgetInstance } from "friendly-challenge";

@Component({
    tag: "ux-iws-sf-captcha",
    styleUrl: "sf-captcha.scss",
    shadow: false,
})
export class SfCaptcha {
    @Element() element: HTMLUxIwsSfCaptchaElement;

    /** FriendlyCaptcha site key */
    @Prop() siteKey: string = "";

    private doneCallback = (solution: unknown) => {
        console.log("CAPTCHA completed succesfully, solution:", solution);
    };

    private loadWidget = () => {
        const widget = new WidgetInstance(
            this.element.querySelector(".frc-captcha"),
            {
                doneCallback: this.doneCallback,
                sitekey: this.siteKey,
            }
        );
        widget.start();
    };

    componentDidLoad() {
        this.loadWidget();
    }

    render() {
        return (
            <Host>
                <div class="frc-captcha"></div>
            </Host>
        );
    }
}
